import {
  START_CALL_SELECT,
  START_CALL_SELECT_CUSTOM,
  START_CALL_FORM_FOCUSED,
  CALL_ONE_TIME
} from 'constants/StartCallModal';

export function selectContactForCall(contact) {
  return {
    type: START_CALL_SELECT,
    payload: contact
  };
}

export const selectCustomContactForCall = (contact) => {
  return {
    type: START_CALL_SELECT_CUSTOM,
    payload: contact
  };
};

export function setFormFocus(isFocused) {
  return {
    type: START_CALL_FORM_FOCUSED,
    payload: isFocused
  };
}

export function callOneTimeMeeting() {
  return {
    type: CALL_ONE_TIME,
  };
}

export default {
  selectContactForCall,
  selectCustomContactForCall,
  setFormFocus,
  callOneTimeMeeting
};
